import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner,
  Badge,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"

import SimpleBar from "simplebar-react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { getStockBalance as onGetStockBalanceDirect } from "helpers/backend_helper"
import { getOtherUnits as getOtherUnitsDirect } from "helpers/backend_helper"

import "../../components/CommonForBoth/rightbar.scss"
import { each } from "lodash"

const PurchaseMoreDrawer = props => {

  const focusRef = useRef();

  useEffect(() => {
    if(props.open){
      if(focusRef && focusRef.current){
        focusRef.current.focus();
      }
      document.getElementById('id-inpcode-mrp-pp').focus();
      document.getElementById('id-inpcode-mrp-pp').select();
      setOriginalData(props.currentItem)
      setShowLoading(true)
      setUseCurrentRate(false)
      //console.log('props.currentItem::'+JSON.stringify(props.currentItem))
      if(props.currentItem.purchaseRateType){
        setPurchaseRateType(props.currentItem.purchaseRateType)
      }
      setSaleDetails({
        ...props.currentItem,
        mrpprofit : getProfitAmount(props.currentItem.mrppercentage),
        retailprofit : getProfitAmount(props.currentItem.retailpercentage),
        wholesaleprofit : getProfitAmount(props.currentItem.wholesalepercentage),
        onlineprofit : getProfitAmount(props.currentItem.onlinepercentage),
        onlinehighlightedprofit : getProfitAmount(props.currentItem.onlinehighlightedpercentage),
      })
      getProductBalance(props.currentItem?.productid)
      //setPurchaseRateType('rprate')
      if(props.currentItem?.multiunit){
        getOtherUnits(props.currentItem?.productid)
      }
      //console.log('>>'+JSON.stringify(props.currentItem))
    }
    else{
      //resetting when drawer is closed
      setcustomActiveTab("1")
      setProductBalance('')
      setOtherUnits([])
      //setPurchaseRateType('rprate')
    }
    
  }, [props.open])
  //}, [props.currentItem?.productid,props.currentItem?.productqty,props.currentItem?.productrate,props.currentItem?.productrate,props.currentItem?.productdisc])
 
  function getAverage(currentAmt, balanceqty, newAmt){
    return (Number(currentAmt * balanceqty) + Number(originalData.productqty * newAmt))/(Number(balanceqty)+Number(originalData.productqty))
  }

  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [showLoading, setShowLoading] = useState(false)
  const [useCurrentRate, setUseCurrentRate] = useState(false)
  const [purchaseRateType, setPurchaseRateType] = useState('rprate');
  const [productBalance, setProductBalance] = useState('')
  const [originalData, setOriginalData] = useState()
  const [otherUnits, setOtherUnits] = useState([])
  const [averageSellRate, setAverageSellRate] = useState({
    rateperitem: "",
    mrp: "",
    retailprice :"",
    wholesaleprice :"",
    onlineprice :"",
    onlinehighlightedprice :"",
  })
  const [saleDetails, setSaleDetails] = useState({
    profitpercentage: "",
    profitamount:"",
    mrppercentage:"0",
    mrpprofit:"0",
    mrp:"0",
    retailpercentage:"0",
    retailprofit:"0",
    retailprice:"0",
    wholesalepercentage:"0",
    wholesaleprofit:"0",
    wholesaleprice:"0",
    onlinepercentage:"0",
    onlineprofit:"0",
    onlineprice:"0",
    onlinehighlightedpercentage:"0",
    onlinehighlightedprofit:"0",
    onlinehighlightedprice:"0",
    currentbaseprice:"",
    currentmrp:"",
    currentretailprice:"",
    currentwholesaleprice:"",
    currentonlineprice:"",
    currentonlinehighlightedprice:"",

    rateperitem: "",
    sellrateperitem :"",
    sellmrp :"",
    sellretailprice :"",
    sellwholesaleprice :"",
    sellonlineprice :"",
    sellonlinehighlightedprice :"",
  })

  useEffect(() => {
    recalculateAverage()
  }, [productBalance,purchaseRateType,saleDetails]);

  useEffect(() => {
    recalculateAverageForOtherUnits()
  }, [productBalance,purchaseRateType]);

  function recalculateAverage(){
    if(productBalance != '' && Number(productBalance) >= 0){
      //console.log('originalData:'+JSON.stringify(originalData))
      setAverageSellRate({
        rateperitem: getAverage(originalData.currentbaseprice,productBalance,saleDetails.productrate).toFixed(2),
        mrp : getAverage(originalData.currentmrp,productBalance,saleDetails.mrp).toFixed(2),
        retailprice : getAverage(originalData.currentretailprice,productBalance,saleDetails.retailprice).toFixed(2),
        wholesaleprice : getAverage(originalData.currentwholesaleprice,productBalance,saleDetails.wholesaleprice).toFixed(2),
        onlineprice : getAverage(originalData.currentonlineprice,productBalance,saleDetails.onlineprice).toFixed(2),
        onlinehighlightedprice : getAverage(originalData.currentonlinehighlightedprice,productBalance,saleDetails.onlinehighlightedprice).toFixed(2),
      })
    }
  }

  function recalculateAverageForOtherUnits(){
    let updatedwithAvg = recalculateAverageForOtherUnitsFromInp(otherUnits)
    setOtherUnits(updatedwithAvg)
  }

  function recalculateAverageForOtherUnitsFromInp(otherUnitsAsInp){
    if(productBalance != '' && Number(productBalance) >= 0){
      let otherUnitsTemp = otherUnitsAsInp.map(each => {
        return {
          ...each,
          mrpaverage : getAverage(each.currentmrp, productBalance, each.mrp).toFixed(2),
          retailaverage : getAverage(each.currentretailprice, productBalance, each.retailprice).toFixed(2),
          wholesaleaverage : getAverage(each.currentwholesaleprice, productBalance, each.wholesaleprice).toFixed(2),
          onlineaverage : getAverage(each.currentonlineprice, productBalance, each.onlineprice).toFixed(2),
          onlinehighlightedaverage : getAverage(each.currentonlinehighlightedprice, productBalance, each.onlinehighlightedprice).toFixed(2),
        }
      })
      return otherUnitsTemp
    }
    else{
      return otherUnitsAsInp
    }
  }

  async function getProductBalance(productid){
    if(productid && productid != ''){
      const balancecount = await onGetStockBalanceDirect({'inputKey':productid})
      if(balancecount && balancecount.stockbalance){
        setProductBalance(balancecount.stockbalance)
      }
      setShowLoading(false)
    }
  }
  
  async function getOtherUnits(productid){
    if(productid && productid != ''){
      let otherUnitsList = await getOtherUnitsDirect({'inputKey':productid})
      let otherUnitsListModified = otherUnitsList.map(each => {
        const mrppercentagetemp = props.currentItem.mrppercentage
        const retailpercentagetemp = props.currentItem.retailpercentage
        const wholesalepercentagetemp = props.currentItem.wholesalepercentage
        const onlinepercentagetemp = props.currentItem.onlinepercentage
        const onlinehighlightedpercentagetemp = props.currentItem.onlinehighlightedpercentage
        /*
        const mrppercentagetemp =  isNumber(each["mrppercentage"]) ? each["mrppercentage"] : props.currentItem.mrppercentage
        const retailpercentagetemp =  isNumber(each["retailpercentage"]) ? each["retailpercentage"] : props.currentItem.retailpercentage
        const wholesalepercentagetemp =  isNumber(each["wholesalepercentage"]) ? each["wholesalepercentage"] : props.currentItem.wholesalepercentage
        const onlinepercentagetemp =  isNumber(each["onlinepercentage"]) ? each["onlinepercentage"] : props.currentItem.onlinepercentage
        const onlinehighlightedpercentagetemp =  isNumber(each["onlinehighlightedpercentage"]) ? each["onlinehighlightedpercentage"] : props.currentItem.onlinehighlightedpercentage
        */
        return {
          ...each,
          rateperitem : getRatePerItem(each["conversionvalue"]),
          currentmrp : each["mrp"] ? each["mrp"] : '',
          mrppercentage : mrppercentagetemp,
          mrpprofit : getProfitAmountFromConversion(mrppercentagetemp,each["conversionvalue"]),
          mrp : getSaleAmountFromConversion(mrppercentagetemp,each["conversionvalue"]),
          currentretailprice: each["retailprice"] ? each["retailprice"] : '',
          retailpercentage : retailpercentagetemp,
          retailprofit : getProfitAmountFromConversion(retailpercentagetemp,each["conversionvalue"]),
          retailprice : getSaleAmountFromConversion(retailpercentagetemp,each["conversionvalue"]),
          currentwholesaleprice: each["wholesaleprice"] ? each["wholesaleprice"] : '',
          wholesalepercentage : wholesalepercentagetemp,
          wholesaleprofit : getProfitAmountFromConversion(wholesalepercentagetemp,each["conversionvalue"]),
          wholesaleprice : getSaleAmountFromConversion(wholesalepercentagetemp,each["conversionvalue"]) ,
          currentonlineprice: each["onlineprice"] ? each["onlineprice"] : '',
          onlinepercentage : onlinepercentagetemp,
          onlineprofit : getProfitAmountFromConversion(onlinepercentagetemp,each["conversionvalue"]),
          onlineprice : getSaleAmountFromConversion(onlinepercentagetemp,each["conversionvalue"]),
          currentonlinehighlightedprice: each["onlinehighlightedprice"] ? each["onlinehighlightedprice"] : '',
          onlinehighlightedpercentage : onlinehighlightedpercentagetemp,
          onlinehighlightedprofit : getProfitAmountFromConversion(onlinehighlightedpercentagetemp,each["conversionvalue"]),
          onlinehighlightedprice : getSaleAmountFromConversion(onlinehighlightedpercentagetemp,each["conversionvalue"]),
        }
      })

      let withAvg = recalculateAverageForOtherUnitsFromInp(otherUnitsListModified)
      setOtherUnits(withAvg)
      //recalculateAverageForOtherUnits()
    }
  }

  const onCloseRightBar = () => {
    const { onClose } = props
    if (onClose) {
      onClose()
    }
  }

  function setPriceBasedOnType(){
    let otherUnitsTemp = otherUnits.map(each => {
      return {
        ...each,
        mrp :  purchaseRateType == 'aprate' ? each.mrpaverage : each.mrp,
        retailprice :  purchaseRateType == 'aprate' ? each.retailaverage : each.retailprice,
        wholesaleprice :  purchaseRateType == 'aprate' ? each.wholesaleaverage : each.wholesaleprice,
        onlineprice :  purchaseRateType == 'aprate' ? each.onlineaverage : each.onlineprice,
        onlinehighlightedprice :  purchaseRateType == 'aprate' ? each.onlinehighlightedaverage : each.onlinehighlightedprice,
      }
    })
    return otherUnitsTemp
  }

  const saveMoreDetailsItem = () => {
    props.onNewlyAddedValue({
      ...originalData,
      profitpercentage: saleDetails.profitpercentage,
      profitamount: saleDetails.profitamount,
      mrppercentage: saleDetails.mrppercentage,
      mrp: saleDetails.mrp,
      retailpercentage: saleDetails.retailpercentage,
      retailprice: saleDetails.retailprice,
      wholesalepercentage: saleDetails.wholesalepercentage,
      wholesaleprice: saleDetails.wholesaleprice,
      onlinepercentage: saleDetails.onlinepercentage,
      onlineprice: saleDetails.onlineprice,
      onlinehighlightedpercentage: saleDetails.onlinehighlightedpercentage,
      onlinehighlightedprice: saleDetails.onlinehighlightedprice,
      addedmoredetails: true,
      otherunitsprice : setPriceBasedOnType(),
      purchaseRateType : purchaseRateType,

      sellrateperitem :  purchaseRateType == 'aprate' ? averageSellRate.rateperitem : saleDetails.rateperitem,
      sellmrp : purchaseRateType == 'aprate' ? averageSellRate.mrp : saleDetails.mrp,
      sellretailprice : purchaseRateType == 'aprate' ? averageSellRate.retailprice : saleDetails.retailprice,
      sellwholesaleprice : purchaseRateType == 'aprate' ? averageSellRate.wholesaleprice : saleDetails.wholesaleprice,
      sellonlineprice : purchaseRateType == 'aprate' ? averageSellRate.onlineprice : saleDetails.onlineprice,
      sellonlinehighlightedprice : purchaseRateType == 'aprate' ? averageSellRate.onlinehighlightedprice : saleDetails.onlinehighlightedprice,
    })
    props.onClose()
  }

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  function getSaleAmount(profitpercentage){
    return (Number(props.currentItem.rateperitem) + (props.currentItem.rateperitem * Number(profitpercentage))/100).toFixed(2)
  }

  function getProfitAmount(profitpercentage){
    return ((props.currentItem.rateperitem * Number(profitpercentage))/100).toFixed(2)
  }

  function getProfitPercentage(profitamount){
    return Number((profitamount/props.currentItem.rateperitem)*100).toFixed(2)
  }

  function getSaleAmountFromProfit(profitamount){
    return (Number(props.currentItem.rateperitem) + Number(profitamount)).toFixed(2)
  }

  function getProfitPercentageFromSale(saleamount){
    return Number(((saleamount-props.currentItem.rateperitem)/props.currentItem.rateperitem)*100).toFixed(2)
  }

  function getProfitFromSale(saleamount){
    return (Number(saleamount) - Number(props.currentItem.rateperitem)).toFixed(2)
  }

  
  function getRatePerItem(conversion){
    return (Number(props.currentItem.rateperitem) / Number(conversion)).toFixed(2)
  }

  function getProfitAmountFromConversion(profitpercentage, conversion){
    const ratePerItemForThis = getRatePerItem(conversion)
    return ((ratePerItemForThis * Number(profitpercentage))/100).toFixed(2)
  }
  function getSaleAmountFromConversion(profitpercentage, conversion){
    const ratePerItemForThis = getRatePerItem(conversion)
    return (Number(ratePerItemForThis) + (ratePerItemForThis * Number(profitpercentage))/100).toFixed(2)
  }
  function getProfitPercentageFromConversion(profitamount,conversion){
    const ratePerItemForThis = getRatePerItem(conversion)
    return Number((profitamount/ratePerItemForThis)*100).toFixed(2)
  }
  function getSaleAmountFromProfitFromConversion(profitamount,conversion){
    const ratePerItemForThis = getRatePerItem(conversion)
    return (Number(ratePerItemForThis) + Number(profitamount)).toFixed(2)
  }
  function getProfitPercentageFromSaleFromConversion(saleamount,conversion){
    const ratePerItemForThis = getRatePerItem(conversion)
    return Number(((saleamount-ratePerItemForThis)/ratePerItemForThis)*100).toFixed(2)
  }
  function getProfitFromSaleFromConversion(saleamount,conversion){
    const ratePerItemForThis = getRatePerItem(conversion)
    return (Number(saleamount) - Number(ratePerItemForThis)).toFixed(2)
  }

  function handleChangeForConversion(id, key1, key2, key3, val1, val2, val3) {
    var modifiedRows = [...otherUnits]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["id"] == id){

        eachRow[key1] = val1
        eachRow[key2] = val2
        eachRow[key3] = val3

        return {
          ...eachRow,
        }
      }
      else {
        return eachRow
      }
    })
    setOtherUnits(modifiedRows)
    recalculateAverageForOtherUnits()
  }

  /*
  useEffect(() => {
    console.log('otherUnits::'+JSON.stringify(otherUnits))
  }, [otherUnits]);
*/
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ height: "900px" }}>
        <div data-simplebar className="h-100">
          <div className="rightbar-title px-3 py-4">
            <Link
              to="#"
              onClick={e => {
                onCloseRightBar()
              }}
              className="right-bar-toggle float-end"
            >
              <i className="mdi mdi-close noti-icon" />
            </Link>
            <h5 className="m-0">{props.isEdit===true?'Edit Sale Details':'Add Sale Details'}</h5>
          </div>

          <hr className="my-0" />

          <Container fluid={true}>
            <Card>
              <CardBody>
              <Form>
                <div className="wizard clearfix">
                  <Row>
                    <Col lg="12">
                      <div className="mb-3">
                        <Label for="inpcode-pppc">
                          Item Name
                        </Label>
                        <Input
                          type="text"
                          value={props.currentItem.productname || ''}
                          className="form-control"
                          disabled
                          id="inpcode-pppc"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Nav tabs className="nav-tabs-custom nav-justified">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: customActiveTab === "1",
                        })}
                        onClick={() => {
                          toggleCustom("1")
                        }}
                      >
                        <span className="">{props.currentItem.unitname || ''}</span>
                      </NavLink>
                    </NavItem>
                    {otherUnits && 
                    otherUnits.map((item, i) => (
                      
                      <NavItem key={i}>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: customActiveTab == i+2,
                          })}
                          onClick={() => {
                            toggleCustom(i+2)
                          }}
                        >
                          <span className="">{item.conversionunitname || ''}</span>
                        </NavLink>
                      </NavItem>
                     
                      ))}
                  </Nav>
                  <TabContent
                    activeTab={customActiveTab}
                    className="p-3 text-muted"
                  >
                    <TabPane tabId="1">
                      <Row>
                        <Col lg="6">
                          <div className="mb-0">
                            <Label for="inpcode-rpi">
                              Rate per Item
                            </Label>
                            <Badge className="ms-2 font-size-13 bg-warning badge-warning">
                              {props.currentItem.rateperitem || ''}
                            </Badge>
                          </div>
                        </Col>
                        <Col lg="6">
                            <div className="d-flex square-switch align-self-center justify-content-end">
                            <Label for="inpcode-rpiucr" className="me-1">
                              Use Current Rate
                            </Label>
                              <input
                                type="checkbox"
                                id="square-switch-currprice"
                                switch="none"
                                disabled={saleDetails.currentmrp == '0' || saleDetails.currentmrp==''}
                                checked={useCurrentRate}
                                onChange={() => {
                                  if(!useCurrentRate){
                                    setSaleDetails({
                                      ...saleDetails,
                                      mrppercentage : getProfitPercentageFromSale(saleDetails.currentmrp),
                                      mrpprofit: getProfitFromSale(saleDetails.currentmrp),
                                      mrp : saleDetails.currentmrp,
                                      retailpercentage : getProfitPercentageFromSale(saleDetails.currentretailprice),
                                      retailprofit: getProfitFromSale(saleDetails.currentretailprice),
                                      retailprice : saleDetails.currentretailprice,
                                      wholesalepercentage : getProfitPercentageFromSale(saleDetails.currentwholesaleprice),
                                      wholesaleprofit: getProfitFromSale(saleDetails.currentwholesaleprice),
                                      wholesaleprice : saleDetails.currentwholesaleprice,
                                    })
                                  }
                                  else{
                                    setSaleDetails({
                                      ...saleDetails,
                                      mrppercentage : props.profitPercentageSettings.mrp,
                                      mrpprofit: getProfitAmount(props.profitPercentageSettings.mrp),
                                      mrp : getSaleAmount(props.profitPercentageSettings.mrp),
                                      retailpercentage : props.profitPercentageSettings.retail,
                                      retailprofit: getProfitAmount(props.profitPercentageSettings.retail),
                                      retailprice : getSaleAmount(props.profitPercentageSettings.retail),
                                      wholesalepercentage : props.profitPercentageSettings.wholesale,
                                      wholesaleprofit: getProfitAmount(props.profitPercentageSettings.wholesale),
                                      wholesaleprice : getSaleAmount(props.profitPercentageSettings.wholesale),
                                    })
                                  }
                                  setUseCurrentRate(!useCurrentRate)
                                }}
                              />
                              <label
                                htmlFor="square-switch-currprice"
                                data-on-label="Yes"
                                data-off-label="No"
                                className="mb-0"
                              />
                            </div>
                        </Col>
                      </Row>
                      <Row className="no-gutters text-center custom-table-header mt-2">
                        <Col lg="3" className="custom-table-header-cell">
                            Type
                        </Col>
                        <Col lg="2" className="custom-table-header-cell">
                          Current Rate
                        </Col>
                        <Col lg="2" className="custom-table-header-cell">
                          Profit %
                        </Col>
                        <Col lg="2" className="custom-table-header-cell">
                          Profit Amount
                        </Col>
                        <Col lg="3" className="custom-table-header-cell">
                          Sale Rate
                        </Col>
                      </Row>
                      <Row className="no-gutters text-center">
                        <Col lg="3">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value="MRP"
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={saleDetails.currentmrp || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            autoFocus="autofocus"
                            ref={focusRef}
                            value={saleDetails.mrppercentage || ''}
                            className="nopadd text-center form-control"
                            id="id-inpcode-mrp-pp"
                            maxLength="15"
                            onChange={event => {
                              if (isNumber(event.target.value)) {
                                  setSaleDetails({
                                    ...saleDetails,
                                    mrppercentage : event.target.value,
                                    mrpprofit: getProfitAmount(event.target.value),
                                    mrp : getSaleAmount(event.target.value),
                                  })
                              }
                            }}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            value={saleDetails.mrpprofit || ''}
                            className="nopadd text-center form-control"
                            id="inpcode-mrp-profit"
                            maxLength="15"
                            onChange={event => {
                              if (isNumber(event.target.value)) {
                                  setSaleDetails({
                                    ...saleDetails,
                                    mrppercentage : getProfitPercentage(event.target.value),
                                    mrpprofit: event.target.value,
                                    mrp : getSaleAmountFromProfit(event.target.value),
                                  })
                              }
                            }}
                          />
                        </Col>
                        <Col lg="3">
                          <Input
                            type="text"
                            value={saleDetails.mrp || ''}
                            className="nopadd text-center form-control"
                            id="inpcode-mrp"
                            maxLength="15"
                            onChange={event => {
                              if (isNumber(event.target.value)) {
                                  setSaleDetails({
                                    ...saleDetails,
                                    mrppercentage : getProfitPercentageFromSale(event.target.value),
                                    mrpprofit: getProfitFromSale(event.target.value),
                                    mrp : event.target.value,
                                  })
                              }
                            }}
                          />
                        </Col>
                      </Row>

                      <Row className="no-gutters text-center">
                        <Col lg="3">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value="Retail"
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={saleDetails.currentretailprice || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.retailpercentage || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-mrp-retailpp"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      retailpercentage : event.target.value,
                                      retailprofit: getProfitAmount(event.target.value),
                                      retailprice : getSaleAmount(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.retailprofit || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-retail-profit"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      retailpercentage : getProfitPercentage(event.target.value),
                                      retailprofit: event.target.value,
                                      retailprice : getSaleAmountFromProfit(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="3">
                          <Input
                              type="text"
                              value={saleDetails.retailprice || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-retail-price"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      retailpercentage : getProfitPercentageFromSale(event.target.value),
                                      retailprofit: getProfitFromSale(event.target.value),
                                      retailprice : event.target.value,
                                    })
                                }
                              }}
                            />
                        </Col>
                      </Row>

                      <Row className="no-gutters text-center">
                        <Col lg="3">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value="Wholesale"
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={saleDetails.currentwholesaleprice || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.wholesalepercentage || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-wholesalepp"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      wholesalepercentage : event.target.value,
                                      wholesaleprofit: getProfitAmount(event.target.value),
                                      wholesaleprice : getSaleAmount(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.wholesaleprofit || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-wholesale-profit"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      wholesalepercentage : getProfitPercentage(event.target.value),
                                      wholesaleprofit: event.target.value,
                                      wholesaleprice : getSaleAmountFromProfit(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="3">
                          <Input
                              type="text"
                              value={saleDetails.wholesaleprice || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-wholesale-price"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      wholesalepercentage : getProfitPercentageFromSale(event.target.value),
                                      wholesaleprofit: getProfitFromSale(event.target.value),
                                      wholesaleprice : event.target.value,
                                    })
                                }
                              }}
                            />
                        </Col>
                      </Row>
                      {props.ecomEnabled && 
                      <>
                      <Row className="no-gutters text-center">
                        <Col lg="3">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value="Online"
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={saleDetails.currentonlineprice || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.onlinepercentage || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-onlinepp"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      onlinepercentage : event.target.value,
                                      onlineprofit: getProfitAmount(event.target.value),
                                      onlineprice : getSaleAmount(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.onlineprofit || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-online-profit"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      onlinepercentage : getProfitPercentage(event.target.value),
                                      onlineprofit: event.target.value,
                                      onlineprice : getSaleAmountFromProfit(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="3">
                          <Input
                              type="text"
                              value={saleDetails.onlineprice || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-online-price"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      onlinepercentage : getProfitPercentageFromSale(event.target.value),
                                      onlineprofit: getProfitFromSale(event.target.value),
                                      onlineprice : event.target.value,
                                    })
                                }
                              }}
                            />
                        </Col>
                      </Row>

                      <Row className="no-gutters text-center">
                        <Col lg="3">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value="Online Extra"
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={saleDetails.currentonlinehighlightedprice || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.onlinehighlightedpercentage || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-onlinehighlightedpp"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      onlinehighlightedpercentage : event.target.value,
                                      onlinehighlightedprofit: getProfitAmount(event.target.value),
                                      onlinehighlightedprice : getSaleAmount(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="2">
                          <Input
                              type="text"
                              value={saleDetails.onlinehighlightedprofit || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-onlinehighlighted-profit"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      onlinehighlightedpercentage : getProfitPercentage(event.target.value),
                                      onlinehighlightedprofit: event.target.value,
                                      onlinehighlightedprice : getSaleAmountFromProfit(event.target.value),
                                    })
                                }
                              }}
                            />
                        </Col>
                        <Col lg="3">
                          <Input
                              type="text"
                              value={saleDetails.onlinehighlightedprice || ''}
                              className="nopadd text-center form-control"
                              id="inpcode-onlinehighlighted-price"
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                    setSaleDetails({
                                      ...saleDetails,
                                      onlinehighlightedpercentage : getProfitPercentageFromSale(event.target.value),
                                      onlinehighlightedprofit: getProfitFromSale(event.target.value),
                                      onlinehighlightedprice : event.target.value,
                                    })
                                }
                              }}
                            />
                        </Col>
                      </Row>
                      </>}
                    </TabPane>
                    {otherUnits && 
                  otherUnits.map((item, i) => (
                    
                      <TabPane tabId={i+2} key={i}>
                        <Row>
                          <Col lg="6">
                            <div className="mb-0">
                              <Label for="inpcode-rpi">
                                Rate per Item
                              </Label>
                              <Badge className="ms-2 font-size-13 bg-warning badge-warning">
                                {item.rateperitem || ''}
                              </Badge>
                            </div>
                          </Col>                    
                        </Row>
                        <Row className="no-gutters text-center custom-table-header mt-2">
                          <Col lg="3" className="custom-table-header-cell">
                              Type
                          </Col>
                          <Col lg="2" className="custom-table-header-cell">
                            Current Rate
                          </Col>
                          <Col lg="2" className="custom-table-header-cell">
                            Profit %
                          </Col>
                          <Col lg="2" className="custom-table-header-cell">
                            Profit Amount
                          </Col>
                          <Col lg="3" className="custom-table-header-cell">
                            Sale Rate
                          </Col>
                        </Row>

                        <Row className="no-gutters text-center">
                          <Col lg="3">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value="MRP"
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value={item.currentmrp || ''}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.mrppercentage || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-mrp-pp_"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'mrppercentage','mrpprofit','mrp',event.target.value,getProfitAmountFromConversion(event.target.value,item.conversionvalue),getSaleAmountFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.mrpprofit || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-mrp-profit"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'mrppercentage','mrpprofit','mrp',getProfitPercentageFromConversion(event.target.value,item.conversionvalue),event.target.value,getSaleAmountFromProfitFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="3">
                            <Input
                              type="text"
                              value={item.mrp || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-mrp"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'mrppercentage','mrpprofit','mrp',getProfitPercentageFromSaleFromConversion(event.target.value,item.conversionvalue),getProfitFromSaleFromConversion(event.target.value,item.conversionvalue),event.target.value)
                                }
                              }}
                            />
                          </Col>
                        </Row>

                        <Row className="no-gutters text-center">
                          <Col lg="3">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value="Retail"
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value={item.currentretailprice || ''}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.retailpercentage || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-retail-pp_"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'retailpercentage','retailprofit','retailprice',event.target.value,getProfitAmountFromConversion(event.target.value,item.conversionvalue),getSaleAmountFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.retailprofit || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-retail-profit"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'retailpercentage','retailprofit','retailprice',getProfitPercentageFromConversion(event.target.value,item.conversionvalue),event.target.value,getSaleAmountFromProfitFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="3">
                            <Input
                              type="text"
                              value={item.retailprice || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-retail"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'retailpercentage','retailprofit','retailprice',getProfitPercentageFromSaleFromConversion(event.target.value,item.conversionvalue),getProfitFromSaleFromConversion(event.target.value,item.conversionvalue),event.target.value)
                                }
                              }}
                            />
                          </Col>
                        </Row>

                        <Row className="no-gutters text-center">
                          <Col lg="3">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value="Wholesale"
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value={item.currentwholesaleprice || ''}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.wholesalepercentage || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-wholesale-pp_"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'wholesalepercentage','wholesaleprofit','wholesaleprice',event.target.value,getProfitAmountFromConversion(event.target.value,item.conversionvalue),getSaleAmountFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.wholesaleprofit || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-wholesale-profit"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'wholesalepercentage','wholesaleprofit','wholesaleprice',getProfitPercentageFromConversion(event.target.value,item.conversionvalue),event.target.value,getSaleAmountFromProfitFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="3">
                            <Input
                              type="text"
                              value={item.wholesaleprice || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-wholesale"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'wholesalepercentage','wholesaleprofit','wholesaleprice',getProfitPercentageFromSaleFromConversion(event.target.value,item.conversionvalue),getProfitFromSaleFromConversion(event.target.value,item.conversionvalue),event.target.value)
                                }
                              }}
                            />
                          </Col>
                        </Row>

                        {props.ecomEnabled && 
                        <>
                        <Row className="no-gutters text-center">
                          <Col lg="3">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value="Online"
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value={item.currentonlineprice || ''}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.onlinepercentage || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-online-pp_"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'onlinepercentage','onlineprofit','onlineprice',event.target.value,getProfitAmountFromConversion(event.target.value,item.conversionvalue),getSaleAmountFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.onlineprofit || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-online-profit"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'onlinepercentage','onlineprofit','onlineprice',getProfitPercentageFromConversion(event.target.value,item.conversionvalue),event.target.value,getSaleAmountFromProfitFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="3">
                            <Input
                              type="text"
                              value={item.onlineprice || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-online"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'onlinepercentage','onlineprofit','onlineprice',getProfitPercentageFromSaleFromConversion(event.target.value,item.conversionvalue),getProfitFromSaleFromConversion(event.target.value,item.conversionvalue),event.target.value)
                                }
                              }}
                            />
                          </Col>
                        </Row>

                        <Row className="no-gutters text-center">
                          <Col lg="3">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value="Online Extra"
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              className="nopadd text-center"
                              disabled
                              value={item.currentonlinehighlightedprice || ''}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.onlinehighlightedpercentage || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-onlinehighlighted-pp_"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'onlinehighlightedpercentage','onlinehighlightedprofit','onlinehighlightedprice',event.target.value,getProfitAmountFromConversion(event.target.value,item.conversionvalue),getSaleAmountFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="2">
                            <Input
                              type="text"
                              value={item.onlinehighlightedprofit || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-onlinehighlighted-profit"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'onlinehighlightedpercentage','onlinehighlightedprofit','onlinehighlightedprice',getProfitPercentageFromConversion(event.target.value,item.conversionvalue),event.target.value,getSaleAmountFromProfitFromConversion(event.target.value,item.conversionvalue))
                                }
                              }}
                            />
                          </Col>
                          <Col lg="3">
                            <Input
                              type="text"
                              value={item.onlinehighlightedprice || ''}
                              className="nopadd text-center form-control"
                              id={"inpcode-onlinehighlighted"+i}
                              maxLength="15"
                              onChange={event => {
                                if (isNumber(event.target.value)) {
                                  handleChangeForConversion(item.id, 'onlinehighlightedpercentage','onlinehighlightedprofit','onlinehighlightedprice',getProfitPercentageFromSaleFromConversion(event.target.value,item.conversionvalue),getProfitFromSaleFromConversion(event.target.value,item.conversionvalue),event.target.value)
                                }
                              }}
                            />
                          </Col>
                        </Row>
                        </>
                        }
                      </TabPane>
                    
                  ))}
                  </TabContent>

                  <hr className="mb-0" />

                  <Row className="mt-4">
                    <Col>
                      <div className="form-check form-check-inline form-radio-primary">
                        <input
                          type="radio"
                          id="real-purchase-rate"
                          name="purchaseratetype"
                          className="form-check-input"
                          value="rprate"
                          checked={purchaseRateType=='rprate'}
                          onChange={event => {
                            setPurchaseRateType(event.target.value)
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="real-purchase-rate"
                        >
                          Real Purchase Rate
                        </label>
                      </div>
                      <div className="form-check form-check-inline form-radio-primary">
                        <input
                          type="radio"
                          id="avg-purchase-rate"
                          name="purchaseratetype"
                          value="aprate"
                          checked={purchaseRateType=='aprate'}
                          className="form-check-input"
                          onChange={event => {
                            setPurchaseRateType(event.target.value)
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="avg-purchase-rate"
                        >
                          Average Purchase Rate
                        </label>
                      </div>
                    </Col>
                  </Row>
                  {purchaseRateType == 'aprate' ?
                  <> 
                  <Row className="mt-3">
                    <Col>
                      Old Stock Balance : {showLoading ? <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="" color="primary" /> 
                      : 
                      <Badge className="bg-warning font-size-14">
                          {productBalance}
                      </Badge>
                      }
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col>
                      Effective Selling Rate
                    </Col>
                  </Row>
                  <Row className="no-gutters text-center mt-2">
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value="Unit"
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value="MRP"
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value="Retail"
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value="W. Sale"
                      />
                    </Col>
                    {props.ecomEnabled && 
                    <>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value="Online"
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value="Online Extra"
                      />
                    </Col>
                    </>
                    }
                  </Row>
                  <Row className="no-gutters text-center">
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value={props.currentItem.unitname || ''}
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value={averageSellRate.mrp.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value={averageSellRate.retailprice.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value={averageSellRate.wholesaleprice.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                      />
                    </Col>
                    {props.ecomEnabled && <>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value={averageSellRate.onlineprice.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                      />
                    </Col>
                    <Col lg="2">
                      <Input
                        type="text"
                        className="nopadd text-center"
                        disabled
                        value={averageSellRate.onlinehighlightedprice.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                      />
                    </Col>
                    </>}
                  </Row>

                  {otherUnits && 
                  otherUnits.map((item, i) => (
                    <div key={i}>
                      <Row className="no-gutters text-center">
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={item.conversionunitname || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={item.mrpaverage?.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={item.retailaverage?.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={item.wholesaleaverage?.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                          />
                        </Col>
                        {props.ecomEnabled && <>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={item.onlineaverage?.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                          />
                        </Col>
                        <Col lg="2">
                          <Input
                            type="text"
                            className="nopadd text-center"
                            disabled
                            value={item.onlinehighlightedaverage?.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                          />
                        </Col>
                        </>}
                      </Row>
                    </div>
                  ))}
                  </>
                  : null }
                    
                  <Row>
                    <Col className="pb-5">
                      <Button
                          disabled={showLoading?true:false}
                          color="info"
                          id="purchase-more-save-btn"
                          className="btn w-lg mt-3 float-end btn-info mb-5"
                          onClick={() => {
                            saveMoreDetailsItem()
                          }}
                          >
                            Save
                            {showLoading && <Spinner style={{ width: '1.0rem', height: '1.0rem' }} className="ms-2" color="primary" /> }
                        </Button>
                    </Col>
                  </Row>
                  <div style={{minHeight: "150px"}}>
                  <hr className="mb-5 my-5" />
                  </div>

                </div>
                </Form>
              </CardBody>
            </Card>
          </Container>
         
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

PurchaseMoreDrawer.propTypes = {
  onClose: PropTypes.func,
  onNewlyAddedValue: PropTypes.func,
  currentItem: PropTypes.any,
  detailsForEdit: PropTypes.any,
  isEdit: PropTypes.bool,
  open:PropTypes.bool
}

export default PurchaseMoreDrawer
